import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "./localStorage";
import themeReducer from "./modules/themeReducer";
import avatarSlice from "./modules/avatar";
import throttle from "lodash.throttle";

const rootReducer = combineReducers({
  theme: themeReducer,
  avatar: avatarSlice,
});

const persistedState = loadState();

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
});

store.subscribe(
  throttle(() => {
    saveState({
      theme: store.getState().theme,
    });
  }, 1000)
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
